import React, { PureComponent } from "react";

import  sAction  from "sAction";

import EmailRelatePopup from "../popup/email/EmailRelatePopup";
import EmailAssignPopup from "../popup/email/EmailAssignPopup";
import EmailImportPopup from "../popup/email/EmailImportPopup";
import Button from "../formElements/Button";

import PropTypes from "prop-types";
import { EmailListContextMenu } from "./EmailListContextMenu";
import { EmailListHeader } from "./EmailListHeader";
import { EmailListEmails } from "./EmailListEmails";

export default class EmailList extends PureComponent {
  constructor(props) {
    super(props);

    this.dragImg = "";

    this.state = {
      loading: false,
      anchorEl: null,
      selectedData: [],
      checkedAll: false,
      contextMenuEmail: {}, // aktualni vybrany email (pro context menu)
    };
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    //kdyz se zmeni slozka - zrusi se vsechny zaskrtnute checkboxy
    if (prevProps.selectedFolder.get("way") !== this.props.selectedFolder.get("way")) {
      // console.log("componentDidUpdate()", prevProps, this.props);
      this.setState({
        selectedData: [],
        checkedAll: false,
      });
    }

    //kdyz problehlo vyhledavani nebo zmenila se slozka - scroll nahoru
    if (prevState.loading) {
      this.setState({ loading: false });
    } else if (prevProps.search.mbox !== this.props.search.mbox) {
      document.querySelector(".email__list__body").scrollTop = 0;
    } else if (prevProps.search.page !== this.props.search.page && this.props.search.page === 1) {
      document.querySelector(".email__list__body").scrollTop = 0;
    }
  }

  componentDidMount() {
    this.dragImg = new Image(0, 0);
    this.dragImg.src =
      "data:image/png;base64,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";
  }

  handleOnDragStart = (e) => {
    e.dataTransfer.setDragImage(this.dragImg, 0, 0);
  };

  handleDragOver = (e) => {
    e.preventDefault();
  };

  //otevre se email
  openEmail = (email, e = null, view = undefined) => {
    //uzivatel drzi ctrl - neotevirej email, ale checkboxni
    if (e) {
      if (e.ctrlKey) {
        this.handleCheckboxChange("toggle", email.uid);
        return;
      }
    }
    const sendData = {
      mbox: email.mbox,
      uid: email.uid,
      ieId: email.ieId,
      seen: email.seen,
      way: email.way,
    };

    sAction.emailGetDetail(sendData, this.props.way, view);
  };

  //otevre se email
  openEmailContext = (e = null, view = undefined) => {
    this.closeContextMenu();
    const email = this.state.contextMenuEmail;

    //uzivatel drzi ctrl - neotevirej email, ale checkboxni
    if (e) {
      if (e.ctrlKey) {
        this.handleCheckboxChange("toggle", email.uid);
        return;
      }
    }
    const sendData = {
      mbox: email.mbox,
      uid: email.uid,
      ieId: email.ieId,
      seen: email.seen,
      way: email.way,
    };

    sAction.emailGetDetail(sendData, this.props.way, view);
  };

  // kdyz se odklikne nejaky checkbox
  handleCheckboxChange = (ch, id) => {
    //const id = event.target.value; // vybrane id
    //const ch = event.target.checked; // hodnota checkboxu

    const selectedData = [...this.state.selectedData];

    // zjisti zda mame v selectedData id vybraneho radku (a podle checkbox checked ho bud pridej nebo odeber)
    const index = selectedData.indexOf(id);
    if (index > -1) {
      // ano
      if (ch === false || ch === "toggle") {
        // nalezeno - smazat
        selectedData.splice(index, 1);
      }
    } else if (ch === true || ch === "toggle") {
      // pridej do array
      selectedData.push(id);
    }
    this.setState({ selectedData });
    this.addCheckedEmailsToStore(selectedData);
  };

  handleCheckboxAll = (ch) => {
    const selectedData = [...this.state.selectedData];
    //const ch = e.target.checked; // hodnota checkboxu

    this.props.emails.forEach(({ uid }) => {
      // zjisti zda mame v selectedData id role (a podle checkbox checked ho pridej nebo odeber)
      const index = selectedData.indexOf(uid);

      if (ch === true && index === -1) {
        // pridej do array
        selectedData.push(uid);
      } else if (ch === false && index > -1) {
        // nalezeno - smazat
        selectedData.splice(index, 1);
      }
    });

    this.setState({ selectedData, checkedAll: ch });
    this.addCheckedEmailsToStore(selectedData);
  };

  addCheckedEmailsToStore = (selectedData) => {
    sAction.dsClear();
    sAction.dsAdd("set", this.props.way + "/move/emailUids", selectedData.join("::;::"));
    sAction.dsAdd("set", this.props.way + "/move/action", "emails");
    sAction.dsAdd("set", this.props.way + "/move/sourceIeId", this.props.selectedFolder.get("ieId"));
    sAction.dsAdd("set", this.props.way + "/move/sourceFolder", this.props.selectedFolder.get("mbox"));
    sAction.dsProcess();
  };

  //prida nebo odebere email z oblibenych
  markFlagged = (data) => {
    sAction.rest.post("email/markEmail", data, function() {});
  };

  //razeni emailu (nejnovejsi, nejstarsi atd.)
  sort = (e) => {
    const value = e.target.value;
    if (value === "-") return;

    const [sort, dir] = value.split(" ");

    let newSearch = {
      page: 1,
      start: 0,
      sort,
      dir,
    };

    newSearch = this.props.search.merge(newSearch);

    sAction.emailGetList(newSearch, this.props.way);
    this.setState({ checkedAll: false });
  };

  //oznacit email jako (precteny, neprecteny atd.)
  mark = (e) => {
    const { name, value: type } = e.target;

    if (type === "-") return;

    const { selectedData } = this.state;

    if (name === "seen") {
      let changes = false;
      let changeCount = 0;
      let seen = type === "unread" ? "0" : "1";
      sAction.dsClear();
      this.props.emails.forEach((v) => {
        if (selectedData.indexOf(v.uid) !== -1) {
          if (seen !== v.seen) {
            sAction.dsAdd("set", v.way + "/seen", seen);
            changes = true;
            changeCount += 1;
          }
        }
      });

      if (changes) {
        const folderWay = this.props.selectedFolder.get("way") + "/unseen";
        if (seen === "1") changeCount *= -1;
        sAction.dsAdd("set", folderWay, sAction.dataGet(folderWay) + changeCount);
        sAction.dsProcess();
      }
    }

    if (type === "deleted") sAction.load();
    sAction.rest.post(
      "email/markEmail",
      {
        uids: selectedData,
        type,
        ieId: this.props.selectedFolder.get("ieId"),
        folder: this.props.selectedFolder.get("mbox"),
      },
      () => {
        if (type === "deleted") {
          let newList = {
            page: 1,
            start: 0,
          };

          newList = this.props.search.merge(newList);

          sAction.emailGetList(newList, this.props.way, true, false, true);
          this.setState({ checkedAll: false });
        }
      }
    );
    this.setState({ selectedData: [], checkedAll: false });
  };

  // pouziti pro pocet vysledku na stranku
  // handleChange = ({ target: { name, value } }) => {
  //   let newSearch = {
  //     page: 1,
  //     start: 0,
  //     [name]: value
  //   };
  //
  //   newSearch = this.props.search.merge(newSearch);
  //
  //   sAction.emailGetList(newSearch);
  // };

  //smazani emailu
  delete = () => {
    // Odstranit označené zprávy?
    const msg = sAction.translate("LBL_EMAIL_DELETE_CONFIRM", "Emails");

    sAction.confrim(msg, () => {
      sAction.popupHide();
      this.mark({ target: { value: "deleted", name: "delete" } });
    });
  };

  //strankovani
  goToPage = (page) => {
    if (page < 1) return;

    const { search } = this.props;

    let newList = {
      page,
      start: (page - 1) * search.limit,
    };

    newList = this.props.search.merge(newList);

    sAction.emailGetList(newList, this.props.way, true, true, false);
    this.setState({ loading: true, checkedAll: false });
  };
  //
  // refresh = () => {
  //   sAction.rest.post(
  //     "email/checkEmailProgress",
  //     { currentCount: 0, ieId: this.props.selectedFolder.get("ieId") },
  //     data => {
  //       sAction.routeEmail(true);
  //     }
  //   );
  // };

  renderMenu = () => {
    const { checkedAll, selectedData } = this.state;

    const isSthSelected = !!selectedData.length;

    return (
      <div className="email__list__header">
        <EmailListHeader
          checkedAll={checkedAll}
          isSthSelected={isSthSelected}
          handleCheckboxAll={this.handleCheckboxAll}
          mark={this.mark}
          delete={this.delete}
          sort={this.sort}
        />
      </div>
    );
  };

  //otevreni kontext. menu
  openContextMenu = (event, email) => {
    event.preventDefault();
    this.handleCheckboxChange(true, email.uid);
    this.setState({ anchorEl: event.currentTarget, contextMenuEmail: email });
  };

  //zavreni kontext. menu
  closeContextMenu = () => {
    const { selectedData, contextMenuEmail } = this.state;
    if (selectedData.length === 1 && selectedData[0] === contextMenuEmail.uid) {
      this.handleCheckboxChange(false, contextMenuEmail.uid);
    }
    this.setState({ anchorEl: null });
  };

  openRelationsPopup = () => {
    this.closeContextMenu();
    sAction.rightPanelEmailRelations(this.state.contextMenuEmail.uid);
  };

  openRelatePopup = () => {
    this.closeContextMenu();
    const uids = this.state.selectedData.join("::;::");
    sAction.popup(<EmailRelatePopup uid={uids} />);
  };

  openAssignPopup = () => {
    this.closeContextMenu();
    const uids = this.state.selectedData.join("::;::");
    sAction.popup(
      <EmailAssignPopup
        uids={uids}
        folder={this.props.selectedFolder.get("mbox")}
        ieId={this.props.selectedFolder.get("ieId")}
      />
    );
  };

  openImportPopup = () => {
    this.closeContextMenu();
    const uids = this.state.selectedData.join("::;::");
    sAction.popup(
      <EmailImportPopup
        uid={uids}
        mbox={this.props.selectedFolder.get("mbox")}
        ieId={this.props.selectedFolder.get("ieId")}
      />
    );
  };

  renderEmails = () => {
    const { emails, selectedEmail } = this.props;
    const { selectedData } = this.state;

    return (
      <EmailListEmails
        emails={emails}
        selectedData={selectedData}
        selectedEmail={selectedEmail}
        handleCheckboxChange={this.handleCheckboxChange}
        handleOnDragStart={this.handleOnDragStart}
        handleDragOver={this.handleDragOver}
        openContextMenu={this.openContextMenu}
        openEmail={this.openEmail}
        markFlagged={this.markFlagged}
      />
    );
  };

  renderContextMenu = () => {
    const { anchorEl } = this.state;
    const open = Boolean(anchorEl);
    const isImap = this.props.selectedFolder.get("isImap");
    return (
      <EmailListContextMenu
        openEmail={this.openEmailContext}
        open={open}
        isImap={isImap}
        openRelatePopup={this.openRelatePopup}
        openAssignPopup={this.openAssignPopup}
        openRelationsPopup={this.openRelationsPopup}
        openImportPopup={this.openImportPopup}
        closeContextMenu={this.closeContextMenu}
      />
    );
  };

  scroll = (e) => {
    if (this.state.loading) return;

    const {
      emails: { size },
      search: { page, limit },
    } = this.props;

    if (size / limit === page) {
      const target = e.target;
      const scroll = target.scrollTop;
      var scrollHeight = target.scrollHeight;
      const height = target.clientHeight;
      if (scrollHeight > height) {
        scrollHeight -= height;
      }
      if (scroll >= scrollHeight - 10) {
        this.goToPage(page + 1);
      }
    }
  };

  render() {
    // console.log("render EmailList()", this.props);
    const {
      emails: { size },
      search: { page, limit },
    } = this.props;

    const { loading } = this.state;

    let footer = "";

    if (loading) {
      footer = <div className="spinnerIcon" style={{ height: 30, width: 30 }} />;
    } else if (size / limit === page) {
      footer = (
        <Button className="stillHover" onClick={() => this.goToPage(page + 1)}>
          {/*Načíst další*/}
          {sAction.translate("LBL_EMAIL_LIST_LOAD_MORE", "Emails")}
        </Button>
      );
    } else if (size > 10) {
      // Konec
      footer = sAction.translate("LNK_LIST_END");
    }

    return (
      <React.Fragment>
        {this.renderMenu()}

        {this.renderContextMenu()}

        <div className="email__list__body" onScroll={this.scroll}>
          <table className="email__list__body__table">
            <tbody>{this.renderEmails()}</tbody>
          </table>

          <div className="email__list__footer">{footer}</div>
        </div>
      </React.Fragment>
    );
  }
}

EmailList.propTypes = {
  emails: PropTypes.shape({
    date: PropTypes.string,
    description: PropTypes.string,
    flagged: PropTypes.string,
    from: PropTypes.string,
    hasAttach: PropTypes.number,
    ieId: PropTypes.string,
    isImap: PropTypes.string,
    mbox: PropTypes.string,
    seen: PropTypes.string,
    status: PropTypes.string,
    subject: PropTypes.string,
    to_addrs: PropTypes.string,
    type: PropTypes.string,
    uid: PropTypes.string,
    way: PropTypes.string,
  }).isRequired,
  search: PropTypes.object.isRequired,
  selectedFolder: PropTypes.object.isRequired,
};
